// Markdown links in LLM-written text, for rendering them as real links.
// Web-search models cite inline, e.g. "...history. ([en.wikipedia.org](https://...))".
// Only http(s) targets become links; a URL may hold one level of
// balanced parentheses (Wikipedia's "Fork_(software)").
const LINK = /\[([^\]]+)\]\((https?:\/\/(?:[^\s()]|\([^\s()]*\))+)\)/g;

// Splits text into [{text}] plain segments and [{text, href}] link
// segments, in order. Anything that isn't an http(s) markdown link stays
// plain text.
export function splitMarkdownLinks(text) {
    if (!text) return [];
    const segments = [];
    let last = 0;
    for (const match of text.matchAll(LINK)) {
        if (match.index > last) segments.push({ text: text.slice(last, match.index) });
        segments.push({ text: match[1], href: match[2] });
        last = match.index + match[0].length;
    }
    if (last < text.length) segments.push({ text: text.slice(last) });
    return segments;
}
